import manageOpenAIResponse from "../../../actions/aiFeatures/OpenAI/manageOpenAIResponse";
import { openAIModal } from "../../../actions/modalActions";
import { ownerPrompt } from "../../../lib/AIFeatures/Prompt/ownerPrompt";

const getCarPricing = async ({ location, carType, carFeatures, make, model, year, currency, dispatch }) => {
    try {
        console.log('carFeaturescarFeatures',carFeatures );
        
        const prompt = ownerPrompt.carRentPriceEstimation({
            location,
            carType,
            make,
            model,
            year,
            carFeatures,
            currency
        });

        await dispatch(manageOpenAIResponse({ name: 'aiPricingData', prompt }));
        await dispatch(openAIModal());
    } catch (error) {

    }
}

export default getCarPricing;
